export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/faqs${mapQueryString(query)}`),
    show: (id = {}) => axios.get(`/faqs/${id}`),
    store: (data) => axios.post(`/faqs`, data),
    update: (id, data) => axios.patch(`/faqs/${id}`, data),
    delete: (id) => axios.delete(`/faqs/${id}`),
})